import { render } from "./illustration.vue?vue&type=template&id=9a4d14c6&scoped=true"
import script from "./illustration.vue?vue&type=script&lang=js"
export * from "./illustration.vue?vue&type=script&lang=js"

import "./illustration.vue?vue&type=style&index=0&id=9a4d14c6&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a4d14c6"]])

export default __exports__